export const calculatePinLimitTime = (pinTimeout: number) => Math.ceil(pinTimeout / 60);
